import { useState } from 'react';

import { WalletCard } from '@givebacks/api/backer';
import { MembershipCard, Stack, ViewMembershipModal } from 'ui';

const ConsumerWalletMembership = ({ walletCard }: { walletCard: WalletCard }) => {
  const [opened, setOpened] = useState(false);

  return (
    walletCard.membership && (
      <>
        <Stack component={'button'}>
          <MembershipCard
            onClick={() => setOpened(true)}
            membership={walletCard.membership}
            isWalletCard
          />
        </Stack>
        <ViewMembershipModal
          opened={opened}
          showDetails
          membership={walletCard.membership}
          onClose={() => setOpened(false)}
        />
      </>
    )
  );
};

export { ConsumerWalletMembership };
